import script from "./CopyRightComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyRightComponent.vue?vue&type=script&setup=true&lang=js"

import "./CopyRightComponent.vue?vue&type=style&index=0&id=4fb71304&lang=css"

const __exports__ = script;

export default __exports__